module.exports = __webpack_public_path__ + "static/media/2.pic.3d25fe1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/2.pic.jpg
// module id = 350
// module chunks = 0